module.exports = __webpack_public_path__ + "static/L2_ux_1_2_eg-d778622c3612afea78fa329f7f705fb9.png";